export default "__VITE_ASSET__BhCet5MX__"